const uniqBy = require('lodash.uniqby');

const uniq = (array) => Array.from(new Set(array).values());

const flattenArray = (arrays) => [].concat(...arrays);

const flatMap = (arr, fn) => flattenArray(arr.map(fn));

// [['a', '1'], ['b', 2], …] -> { a: 1, b: 2, … }
const arrayToHashmap = (array) => (
    Object.assign({}, ...array.map(([key, val]) => ({ [key]: val })))
);

const sumBy = (arr, fn) => (
    arr.reduce((total, item) => total + parseFloat(fn(item)), 0)
);

const sum = (arr) => (
    arr.reduce((total, item) => total + parseFloat(item), 0)
);

const getArrayChunks = (array, maxItemsPerChunk) => {
    const res = [];

    for (let i = 0; array.length > i * maxItemsPerChunk; i += 1) {
        res.push(
            array.slice(i * maxItemsPerChunk, (i * maxItemsPerChunk) + maxItemsPerChunk)
        );
    }

    return res;
};

module.exports = {
    uniq,
    uniqBy,
    flattenArray,
    flatMap,
    arrayToHashmap,
    sumBy,
    sum,
    getArrayChunks,
};
